import React, { useEffect, useState } from 'react';
import { IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCheckbox, IonChip, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonList, IonPage, IonProgressBar, IonRange, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import { useParams } from 'react-router';
import { checkmarkCircleOutline } from 'ionicons/icons';
import { informationCircle, videocamOutline,bookOutline , helpOutline} from 'ionicons/icons';

interface Answer {
  text: string;
  isCorrect: boolean;
  selected: boolean;
}

interface Question {
  question: string;
  answers: Answer[];
}

const Modul: React.FC = () => {
  const [questions, setQuestions] = useState<Question[]>([
    {
      question: "1. Die häufigste Demenzform ist die",
      answers: [
        { text: "vaskuläre Demenz", isCorrect: false, selected: false },
        { text: "Lewy-Körperchen-Demenz", isCorrect: false, selected: false },
        { text: "Alzheimer-Demenz", isCorrect: true, selected: false }
      ]
    },
    {
      question: "2. Ein akuter Verwirrtheitszustand tritt auf bei",
      answers: [
        { text: "einer Depression", isCorrect: true, selected: false },
        { text: "dem Verlust eines nahen Menschen", isCorrect: true, selected: false },
        { text: "der Übersiedlung in ein Pflegeheim", isCorrect: true, selected: false },
        { text: "beim gemeinsamen Singen vertrauter Lieder", isCorrect: false, selected: false }
      ]
    },
    {
      question: "3. Mögliche Kennzeichen einer Demenz:",
      answers: [
        { text: "Erinnerungen verschwinden (Amnesie)", isCorrect: true, selected: false },
        { text: "Worte verschwinden (Aphasie)", isCorrect: true, selected: false },
        { text: "Emotionen versiegen (Apathie)", isCorrect: true, selected: false },
        { text: "Erkennen funktioniert nicht mehr (Agnosie)", isCorrect: true, selected: false },
        { text: "Hände und Füße wollen nicht mehr (Apraxie)", isCorrect: true, selected: false }
      ]
    },
    {
      question: "4. Wie können Menschen mit Demenz mit ihren Verlusterfahrungen umgehen?",
      answers: [
        { text: "Sie müssen trainiert werden, sich in der Gegenwart zurechtzufinden.", isCorrect: false, selected: false },
        { text: "Sie bauen ihr Selbstwertgefühl aus dem vergangenen Leben auf.", isCorrect: true, selected: false },
        { text: "Wenn Betreuer sich auf ihre Welt einlassen, fühlen sie sich mit ihren Gefühlen ernstgenommen.", isCorrect: true, selected: false }
      ]
    },
    {
      question: "5. Eine leichte kognitive Störung (Mild Cognitive Impairment) ist",
      answers: [
        { text: "ein untrüglicher Hinweis auf den Beginn einer Demenz", isCorrect: false, selected: false },
        { text: "Ausdruck eines allgemeinen Alterungsprozesses", isCorrect: true, selected: false },
        { text: "eine geringfügige Gedächtnisschwierigkeit", isCorrect: true, selected: false }
      ]
    },
    {
      question: "6. Wesentliche Aktivitäten für einen Menschen im Frühstadium der Demenz im Hinblick auf eine selbständige Lebensführung sind:",
      answers: [
        { text: "Sich pflegen", isCorrect: true, selected: false },
        { text: "Zeitung lesen", isCorrect: false, selected: false },
        { text: "Sich bewegen", isCorrect: true, selected: false },
        { text: "Kreuzworträtsel lösen", isCorrect: false, selected: false },
        { text: "Ruhen und schlafen", isCorrect: true, selected: false }
      ]
    },
    {
      question: "7. Angehörigen und Betreuerinnen können gut mit Menschen mit Demenz kommunizieren, wenn sie…",
      answers: [
        { text: "die Gefühle des Gegenübers ernstnehmen", isCorrect: true, selected: false },
        { text: "auf Fehler aufmerksam machen", isCorrect: false, selected: false },
        { text: "den anderen drängen, etwas zu tun", isCorrect: false, selected: false },
        { text: "mehr auf den Tonfall und die Mimik, weniger auf den Inhalt des Betreuten achten", isCorrect: true, selected: false },
        { text: "sich bei herausforderndem Verhalten nicht persönlich angegriffen fühlen", isCorrect: true, selected: false }
      ]
    },
    {
      question: "8. Wenn ein Mensch mit Demenz zu Ihnen sagt: „Ich muss meine Kinder von der Schule abholen!, dann antworten Sie:",
      answers: [
        { text: "„Die sind doch schon lange erwachsen.", isCorrect: false, selected: false },
        { text: "„Kommen Sie, gehen wir ein Stück miteinander!\"", isCorrect: true, selected: false },
        { text: "„Das ist aber schön, dass Sie sich um Ihre Kinder sorgen!\"", isCorrect: true, selected: false },
        { text: "„Bleiben Sie hier, die finden ihren Weg doch von allein!\"", isCorrect: false, selected: false }
      ]
    },
    {
      question: "9. Grundemotionen wie Angst oder Wut bei Menschen mit Demenz:",
      answers: [
        { text: "sollten grundsätzlich medikamentös behandelt werden", isCorrect: false, selected: false },
        { text: "bleiben länger erhalten als deren kognitive Steuerung", isCorrect: true, selected: false },
        { text: "werden ausgelöst, wenn eine Überforderung oder Verunsicherung bestehen", isCorrect: true, selected: false },
        { text: "sind verbunden mit körperlichen Reaktionen wie die Erhöhung des Blutdrucks", isCorrect: true, selected: false },
        { text: "sollte man mit Geduld begegnen", isCorrect: true, selected: false }
      ]
    },
    {
      question: "10. Bei aggressivem Verhalten Ihres Gegenübers sollten Sie",
      answers: [
        { text: "ihn deutlich in die Schranken weisen", isCorrect: false, selected: false },
        { text: "notfalls Hilfe holen", isCorrect: true, selected: false },
        { text: "die Gefühle des anderen ernstnehmen", isCorrect: true, selected: false },
        { text: "ihm eine Tätigkeit anbieten, die ihm Freude macht", isCorrect: true, selected: false },
        { text: "feststellen, wo Ihre eigenen Grenzen in der Betreuung liegen", isCorrect: true, selected: false },
        { text: "das Zimmer verlassen und hinter sich abschließen", isCorrect: false, selected: false }
      ]
    },
    {
      question: "11. Wahnvorstellungen bei Menschen mit Demenz sind:",
      answers: [
        { text: "Sinnestäuschungen", isCorrect: false, selected: false },
        { text: "Teil einer kognitiven Veränderung", isCorrect: true, selected: false },
        { text: "bei Alzheimer-Patienten anzutreffen", isCorrect: true, selected: false },
        { text: "Auswirkungen von Stress oder Veränderungen der Umwelt", isCorrect: true, selected: false },
        { text: "gefährlich für Patienten und Betreuer", isCorrect: true, selected: false }
      ]
    },
    {
      question: "12. Vor der Aufnahme einer Patientin mit Demenz im Krankenhaus sollte folgendes beachtet werden:",
      answers: [
        { text: "Angehörige sind nicht erwünscht.", isCorrect: false, selected: false },
        { text: "Prüfen, ob es die Möglichkeit für Rooming-In gibt", isCorrect: true, selected: false },
        { text: "Eine Notfalltasche mit Kontaktdaten, Medikation, Vollmacht, persönlichen Dingen etc. bereithalten", isCorrect: true, selected: false },
        { text: "Ein Hinweis auf Demenzerkrankung ist nicht notwendig.", isCorrect: false, selected: false },
        { text: "Ernährung und Flüssigkeitsversorgung werden in jedem Krankenhaus auch auf die Bedürfnisse von Menschen mit Demenz abgestellt", isCorrect: false, selected: false },
        { text: "Fixierung und Verabreichung von Psychopharmaka sind in jedem Fall die richtigen Maßnahmen bei herausforderndem Verhalten", isCorrect: false, selected: false }
      ]
    },
    {
      question: "13. Enkel und Enkelinnen sind für den Kontakt mit Großvater oder einer Großmutter mit Demenz besonders wichtig, weil sie",
      answers: [
        { text: "Empathie und Geduld lernen", isCorrect: true, selected: false },
        { text: "gerade im jüngeren Alter ein unproblematisches Verhältnis zueinander haben", isCorrect: true, selected: false },
        { text: "auch bei herausforderndem Verhalten besser als Erwachsene reagieren können", isCorrect: true, selected: false },
        { text: "gemeinsame Erinnerungen und Rituale pflegen können", isCorrect: true, selected: false },
        { text: "anstelle ihrer Eltern besser die Großeltern mit Demenz betreuen können", isCorrect: false, selected: false }
      ]
    },
    {
      question: "14. Partnerschaft bei dementieller Erkrankung",
      answers: [
        { text: "Sexuelle Bedürfnisse von Menschen mit Demenz sollen behandelt werden", isCorrect: false, selected: false },
        { text: "Eine gemeinsame erinnerte Vergangenheit und eine erwartete Zukunft sind geschwunden.", isCorrect: false, selected: false },
        { text: "Kleine Rituale der Nähe wie gemeinsames Musikhören oder das Kochen einer Lieblingsspeise können Momente der Liebe aufleuchten lassen", isCorrect: true, selected: false },
        { text: "Im Verlauf der Erkrankungen verändern sich die eingeübten Rollen in der Partnerschaft", isCorrect: true, selected: false },
        { text: "Das Gespür eines Menschen mit Demenz für liebevolle Atmosphäre bleibt trotz kognitiver Beeinträchtigungen noch lange erhalten", isCorrect: true, selected: false }
      ]
    },
    {
      question: "15. Humor",
      answers: [
        { text: "Witze über die Vergesslichkeit oder über sonderbares Verhalten von Menschen mit Demenz erheitern eine Gesprächsrunde", isCorrect: false, selected: false },
        { text: "Komische Situationen im Betreuungsalltag können zum gemeinsamen Lachen reizen", isCorrect: true, selected: false },
        { text: "Humor ist ein Zeichen von Persönlichkeit, die trotz Demenz erhalten bleibt", isCorrect: true, selected: false },
        { text: "Lachen wird dem Charakter einer Demenz-Erkrankung nicht gerecht", isCorrect: false, selected: false }
      ]
    },
    {
      question: "16. Musizieren, Singen, Tanzen",
      answers: [
        { text: "Eine dauerhafte Hintergrundmusik im Pflegealltag hebt die Stimmung", isCorrect: false, selected: false },
        { text: "Selbst wenn das Sprachvermögen stark reduziert ist, können Menschen mit Demenz zum gemeinsamen Musizieren motiviert werden.", isCorrect: true, selected: false },
        { text: "Hinter jedem Laut kann das Bedürfnis stehen, um eine positive oder negative Emotion auszudrücken.", isCorrect: true, selected: false },
        { text: "Tanzen mit Menschen mit Demenz ist nur peinlich.", isCorrect: false, selected: false },
        { text: "Eine beruhigende Musik am Abend hilft zur Entspannung und zum Einschlafen.", isCorrect: true, selected: false }
      ]
    },
    {
      question: "17. Abschied nehmen",
      answers: [
        { text: "Der Trauerprozess beginnt schon lange vor dem Sterben.", isCorrect: true, selected: false },
        { text: "Sinnliche Reize wie Licht, Töne oder Berührungen werden bis zuletzt wahrgenommen.", isCorrect: true, selected: false },
        { text: "Hospizhelferinnen sollen auch in der Sterbephase von Menschen mit Demenz Beistand leisten.", isCorrect: true, selected: false },
        { text: "Spirituelle Begleitung sollte sich an biographisch verankerten und vertrauten Ritualen und Symbolen orientieren.", isCorrect: true, selected: false },
        { text: "Wenn die kognitive Leistungsfähigkeit ganz verschwunden ist, kann der Mensch mit Demenz nichts mehr wahrnehmen.", isCorrect: false, selected: false }
      ]
    },
    {
      question: "18. Selbstfürsorge von Angehörigen",
      answers: [
        { text: "Sie müssen immer für Ihren erkrankten Angehörigen präsent sein.", isCorrect: false, selected: false },
        { text: "Hilfe holen ist ein Zeichen von Schwäche", isCorrect: false, selected: false },
        { text: "Als pflegende Person haben Sie Anspruch auf eine Kur.", isCorrect: true, selected: false },
        { text: "Die Teilnahme an Angehörigen-Gruppen führt nur dazu, dass man durch die Probleme der anderen noch mehr belastet wird.", isCorrect: false, selected: false },
        { text: "Es ist sinnvoll, rechtzeitig für eine Vorsorgevollmacht und eine Patientenverfügung gesorgt zu haben.", isCorrect: true, selected: false },
        { text: "Ein geliebter Mensch spürt, dass Sie für ihn da sind, auch wenn er nicht mehr reagieren kann.", isCorrect: true, selected: false }
      ]
    }
  ]);

  const toggleAnswer = (questionIndex: number, answerIndex: number) => {
    const newQuestions = [...questions];
    newQuestions[questionIndex].answers[answerIndex].selected = !newQuestions[questionIndex].answers[answerIndex].selected;
    setQuestions(newQuestions);
  };

  const getAnswerColor = (answer: Answer): string => {
    if (!answer.selected) {
      return '';
    }
    return answer.isCorrect ? '#4caf50' : '#f44336'; // green for correct, red for incorrect
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle><IonImg src="logo_lichteMomente.png" style={{maxHeight:'5vh',height:"5vh"}}/>Abschlußquiz
</IonTitle>
            
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large"><IonImg src="logo_lichteMomente.png" style={{maxHeight:'10vh',height:"10vh"}}/>Abschlußquiz
</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonCard>
          <IonCardHeader>
            <IonCardTitle>Glückwunsch!
</IonCardTitle>
          </IonCardHeader>

          <IonCardContent>
            <h2>Sie haben es geschafft: </h2>
            <ul>
              <li>Sie haben Fallbeispiele auf sich wirken lassen und sind dabei der Welt von Menschen mit Demenz begegnet.</li>
              <li>Sie haben sich Ihre eigene Haltung in diesen Begegnungen bewusst gemacht, vielleicht etwas Neues erfahren.</li>
              <li>Sie haben Einblick in wesentliche Themen der Begleitung von Menschen mit Demenz gewonnen</li>
              <li>Hoffentlich haben Sie auch zwischendurch etwas Unterhaltsames oder Humorvolles bei noch so ernsten Sachverhalten entdeckt.</li>
              <li>Sie können jetzt das Abschlussquiz nutzen, um zu sehen, was hängen geblieben ist oder wo Sie noch einmal nacharbeiten sollten.</li>
            </ul>
          </IonCardContent>
        </IonCard>
        <IonCard>
          <IonCardHeader>
            <IonCardTitle>Abschlussquiz</IonCardTitle>
            <IonCardSubtitle>Testen Sie Ihr Wissen!</IonCardSubtitle>
          </IonCardHeader>

          <IonCardContent>
            {questions.map((question, questionIndex) => (
              <IonCard key={questionIndex} style={{ marginBottom: '20px', marginTop: '20px' }}>
                <IonCardHeader>
                  <IonCardTitle style={{ fontSize: '18px' }}>{question.question}</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                  <IonList>
                    {question.answers.map((answer, answerIndex) => (
                      <IonItem
                      color={answer.selected && !answer.isCorrect ? 'danger' : 'success' }
                        key={answerIndex}
                        style={{
                          backgroundColor: getAnswerColor(answer),
                          borderRadius: '4px',
                          marginBottom: '8px'
                        }}
                      >
                        <IonCheckbox
                          slot="start"
                          checked={answer.selected}
                          onIonChange={() => toggleAnswer(questionIndex, answerIndex)}
                        />
             
                          {answer.text}
                      
                      </IonItem>
                    ))}
                  </IonList>
                </IonCardContent>
              </IonCard>
            ))}
          </IonCardContent>
        </IonCard>
      </IonContent>
    </IonPage>
  );
};

export default Modul;
